<template>
  <div>
    <t-form ref="form" @submit.prevent>
      <ExecutionPeriodRadioFormPart @change="onChange" @result="onResult" />
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import ExecutionPeriodRadioFormPart from 'chimera/all/components/form/parts/executionPeriod/ExecutionPeriodRadioFormPart'
import NextStep from '~/pages/offertes-aanvragen/je-gegevens'

export default {
  name: 'ExecutionPeriodFormStep',

  components: {
    ExecutionPeriodRadioFormPart,
    FormErrorMessages,
  },

  extends: AbstractFormStep,

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before a component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Transition
     */
    transition() {
      this.routeTo(NextStep)
    },
  },
}
</script>
